// src/components/controller/PlayerProgress.js
import { Button } from 'baseui/button';
import { Input } from 'baseui/input';
import {
  PlayerProgressGrid,
  PlayerProgressItem,
  PlayerProgressLabel,
  PlayerProgressInputGroup,
  PlayerProgressValueDisplay
} from '../../styles/playerProgressStyles';
import { SectionContainer } from '../../styles/controllerPageStyles';

const PlayerProgress = ({
  tournamentDetails,
  handlePlayerProgressChange,
  calculateAverageStack,
  t,
  isReadyEditing
}) => {
  if (!tournamentDetails.showPlayerStats) {
    return null;
  }

  const rebuyInputsDisabled = tournamentDetails.rebuyStack === 0;
  const addonInputsDisabled = tournamentDetails.addonStack === 0;
  const maxKnockouts = (tournamentDetails.initialEntries || 0) + (tournamentDetails.totalRebuys || 0) - 1;
  const knockoutPlusDisabled = tournamentDetails.knockouts >= maxKnockouts;


  return (
    <SectionContainer>
      <PlayerProgressGrid>
        <PlayerProgressItem>
          <PlayerProgressLabel>{t('player.initialEntriesLabel')}</PlayerProgressLabel>
          <PlayerProgressInputGroup>
            <Button size="compact" onClick={() => handlePlayerProgressChange('initialEntries', 'dec')} disabled={isReadyEditing}>-</Button>
            <Input
              type="number"
              value={tournamentDetails.initialEntries}
              onChange={e => handlePlayerProgressChange('initialEntries', parseInt(e.target.value, 10))}
              overrides={{ Input: { style: { textAlign: 'center' }}}}
              disabled={isReadyEditing}
            />
            <Button size="compact" onClick={() => handlePlayerProgressChange('initialEntries', 'inc')} disabled={isReadyEditing}>+</Button>
          </PlayerProgressInputGroup>
        </PlayerProgressItem>

        <PlayerProgressItem>
          <PlayerProgressLabel>{t('player.knockoutsLabel')}</PlayerProgressLabel>
          <PlayerProgressInputGroup>
            <Button size="compact" onClick={() => handlePlayerProgressChange('knockouts', 'dec')} disabled={isReadyEditing}>-</Button>
            <Input
              type="number"
              value={tournamentDetails.knockouts}
              onChange={e => handlePlayerProgressChange('knockouts', parseInt(e.target.value, 10))}
              overrides={{ Input: { style: { textAlign: 'center' }}}}
              disabled={isReadyEditing}
            />
            <Button size="compact" onClick={() => handlePlayerProgressChange('knockouts', 'inc')} disabled={knockoutPlusDisabled || isReadyEditing}>+</Button>
          </PlayerProgressInputGroup>
        </PlayerProgressItem>

        <PlayerProgressItem>
          <PlayerProgressLabel>{t('player.rebuysLabel')}</PlayerProgressLabel>
          <PlayerProgressInputGroup>
            <Button size="compact" onClick={() => handlePlayerProgressChange('totalRebuys', 'dec')} disabled={rebuyInputsDisabled || isReadyEditing}>-</Button>
            <Input
              type="number"
              value={tournamentDetails.totalRebuys}
              onChange={e => handlePlayerProgressChange('totalRebuys', parseInt(e.target.value, 10))}
              overrides={{ Input: { style: { textAlign: 'center' }}}}
              disabled={rebuyInputsDisabled || isReadyEditing}
            />
            <Button size="compact" onClick={() => handlePlayerProgressChange('totalRebuys', 'inc')} disabled={rebuyInputsDisabled || isReadyEditing}>+</Button>
          </PlayerProgressInputGroup>
        </PlayerProgressItem>

        <PlayerProgressItem>
          <PlayerProgressLabel>{t('player.addonsLabel')}</PlayerProgressLabel>
          <PlayerProgressInputGroup>
            <Button size="compact" onClick={() => handlePlayerProgressChange('totalAddons', 'dec')} disabled={addonInputsDisabled || isReadyEditing}>-</Button>
            <Input
              type="number"
              value={tournamentDetails.totalAddons}
              onChange={e => handlePlayerProgressChange('totalAddons', parseInt(e.target.value, 10))}
              overrides={{ Input: { style: { textAlign: 'center' }}}}
              disabled={addonInputsDisabled || isReadyEditing}
            />
            <Button size="compact" onClick={() => handlePlayerProgressChange('totalAddons', 'inc')} disabled={addonInputsDisabled || isReadyEditing}>+</Button>
          </PlayerProgressInputGroup>
        </PlayerProgressItem>

        <PlayerProgressItem>
          <PlayerProgressLabel>{t('player.forfeitedChipsLabel')}</PlayerProgressLabel>
          <PlayerProgressInputGroup>
            <Button size="compact" onClick={() => handlePlayerProgressChange('forfeitedChips', 'dec')} disabled={isReadyEditing}>-</Button>
            <Input
              type="number"
              value={tournamentDetails.forfeitedChips || 0}
              onChange={e => handlePlayerProgressChange('forfeitedChips', parseInt(e.target.value, 10) || 0)}
              overrides={{ Input: { style: { textAlign: 'center' }}}}
              disabled={isReadyEditing}
            />
            <Button size="compact" onClick={() => handlePlayerProgressChange('forfeitedChips', 'inc')} disabled={isReadyEditing}>+</Button>
          </PlayerProgressInputGroup>
        </PlayerProgressItem>
        
        <PlayerProgressItem>
          <PlayerProgressLabel>{t('player.averageStackDisplay')}:</PlayerProgressLabel>
          <PlayerProgressValueDisplay>
            {calculateAverageStack(tournamentDetails).toLocaleString()}
          </PlayerProgressValueDisplay>
        </PlayerProgressItem>
      </PlayerProgressGrid>
    </SectionContainer>
  );
};

export default PlayerProgress;